import React, { useEffect, useState } from 'react';
import SubscribeNow from '../shared/SubscribeNow';
import Slider from 'react-slick';
import style from '../../../packs/slick_carousel_style';
import axios from 'axios';
import { OpportunityCard } from './cards/OpportunityCard';
import { getFieldAttributes } from '../../../api/opportunitiesAPI';

import PurpleLoadingSpinner from '../../../../assets/images/loading-spinner-purple.svg';
import { filterExpiredOpportunities } from '../../utils';

// Partnership Opportunities
export function DiscoverOpportunities({ mask_content, header, isSocial }) {
	const [isLoading, setIsLoading] = useState(false);
	const [recommendedOpportunities, setRecommendedOpportunities] = useState(
		[]
	);
	const [selectedFilterOption, setSelectedFilterOption] = useState({
		label: '',
		value: '',
	});

	useEffect(() => {
		async function fetchOpportunities() {
			setIsLoading(true);
			let endpoint = '/api/opportunities?kind=recommended';

			if (isSocial) {
				endpoint = '/api/opportunities?kind=social';
			}
			const { data: fetchedOpportunities } = await axios.get(endpoint);
			const nonExpiredOpportunites =
				filterExpiredOpportunities(fetchedOpportunities);
			const filteredOpportunities = applyFilter(
				nonExpiredOpportunites,
				selectedFilterOption.value
			);

			setRecommendedOpportunities(filteredOpportunities);
			setIsLoading(false);
		}
		fetchOpportunities();
	}, [selectedFilterOption]);

	const applyFilter = (opportunites, filterType) => {
		if (filterType === '' || filterType === null) {
			return opportunites;
		}

		let filteredOpportunities = [];

		opportunites.forEach((opportunity) => {
			opportunity.opportunity_types.forEach((type) => {
				if (type.name === filterType) {
					filteredOpportunities.push(opportunity);
					return;
				}
			});
		});

		return filteredOpportunities;
	};

	const MaskContent = ({ mask_content, children }) => {
		return (
			<div className="columns small-12 carousel-container masking-wrapper guard-for-empty">
				{mask_content ? (
					<SubscribeNow style={{ marginTop: '5rem' }} />
				) : null}
				{children}
			</div>
		);
	};

	const Header = ({ header }) => {
		const { fields } = header;
		const { title, subtitle } = fields['en-US'];

		return (
			<>
				<div className="row">
					<div className="columns small-12">
						<h3>{title}</h3>
					</div>
				</div>
				<div className="row">
					<div className="columns medium-9 small-12">{subtitle}</div>
				</div>
			</>
		);
	};

	const RecommendedOpportunities = () => {
		if (isLoading) {
			return (
				<div style={{ textAlign: 'center' }}>
					<img
						id="purple-loading-spinner"
						src={PurpleLoadingSpinner}
						alt="Loading spinner"
					/>
				</div>
			);
		}

		return (
			<div className="row">
				<MaskContent mask_content={mask_content}>
					{recommendedOpportunities &&
					recommendedOpportunities.length > 0 ? (
						<Slider {...style}>
							{recommendedOpportunities.map(
								(opportunity, index) => {
									return (
										<OpportunityCard
											key={opportunity.id}
											opportunity={opportunity}
											isSocial={isSocial}
										/>
									);
								}
							)}
						</Slider>
					) : selectedFilterOption.value !== '' &&
					  recommendedOpportunities.length === 0 ? (
						'No results found...'
					) : (
						'When you complete your personal profile and organization profile, our AI powered recommendation engine will provide you with matches in 24 hours!'
					)}
				</MaskContent>
			</div>
		);
	};

	const FilterOpportunities = () => {
		const [opportunityTypeOptions, setOpportunityTypeOptions] = useState(
			[]
		);

		useEffect(() => {
			const fetchOpportunityTypes = async () => {
				const { data } = await getFieldAttributes();
				const { opportunityTypes } = data;

				const opportunityTypesName = opportunityTypes.map(
					(opportunity, index) => {
						if (index === 0) {
							return {
								label: '',
								value: '',
							};
						}

						return {
							label: opportunity.name,
							value: opportunity.name,
						};
					}
				);

				setOpportunityTypeOptions(opportunityTypesName);
			};

			fetchOpportunityTypes();
		}, []);

		return (
			<div className="fitler-opportunity-types">
				<label>Filter by Opportunity Type:</label>
				<div>
					<select
						className="fitler-opportunity-select"
						onChange={({ target }) =>
							setSelectedFilterOption({
								label: target.value,
								value: target.value,
							})
						}
						value={selectedFilterOption.value}
					>
						{opportunityTypeOptions.map((opportunityOption) => {
							return (
								<option
									key={opportunityOption.value}
									value={opportunityOption.value}
								>
									{opportunityOption.label}
								</option>
							);
						})}
					</select>
				</div>
			</div>
		);
	};

	return (
		<div className="recommended-organizations-container">
			<Header header={header} />
			<FilterOpportunities />
			<RecommendedOpportunities />
		</div>
	);
}
